module.exports = __webpack_public_path__ + "img/00037.fff731d2.webp";